import { VisibilityOutlined } from "@mui/icons-material";
import AddSharpIcon from "@mui/icons-material/AddSharp";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import AttachFileIcon from "@mui/icons-material/AttachFile";
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import MarkunreadOutlinedIcon from "@mui/icons-material/MarkunreadOutlined";
import StickyNote2Icon from "@mui/icons-material/StickyNote2";
import WarningIcon from '@mui/icons-material/Warning';
import { IconButton, Tooltip, Typography } from "@mui/material";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import React, { useEffect, useRef, useState, useLayoutEffect } from "react";
import { Form, Table } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import { useHistory, useParams, useLocation } from "react-router";
import barrelListCheck from "../../assets/images/icons/BarrelListCheck.svg";
import DownLoadIcon from '../../assets/images/icons/DownLoadIcon.svg';
import EditIcon from '../../assets/images/icons/EditIcon.svg';
import EditIconWhite from '../../assets/images/icons/EditIconWhite.svg';
import TrashIcon from "../../assets/images/icons/Trash.svg";
import Constant from "../../Constant";
import { CommonService } from "../../Service/CommonService";
import { InventoryApiService } from "../../Service/InventoryApiService";
import { MessageApiService } from "../../Service/MessageApiService";
import { OrderApiService } from "../../Service/OrderApiService";
import Customspinner from "../Common/CustomSpinner";
import { HistoryStepper } from "../Common/HistoryStepper";
import Spinner from "../Common/Spinner";
import StatusDropdown from "../Common/StatusDropdown";
import "../Dynamic/InventoryCSV.scss";
import "../Dynamic/UserList.scss";
import UploadDocs from "../popups/uploadDocs";
import CurrencyFormatter from "../Static/CurrencyFormatter";
import AdminMessageBox from "./AdminMessageBox";
import BarrelSelectionPanel from "./BarrelSelectionPanel";
import ContainerMessageBox from "./ContainerMessageBox";
import EditRequest from "./EditOrderRequest";
import SameInventoryOrders from "./SameInventoryOrders";
import ViewProductDetail from "./ViewProductDetail";
import Select from "react-select";
import ExpandMoreRoundedIcon from "@mui/icons-material/ExpandMoreRounded";



const ViewOfferRequest: React.FC = () => {

  const history = useHistory();
  const location = useLocation();
  const { id } = useParams<{ id: string }>();
  const [isLoading, setIsLoading] = useState(false);
  const [offerRequest, setOfferRequest] = useState<any>(null);
  const [offerRequestDocs, setOfferRequestDocs] = useState<any[]>([]);
  const [offerRequestHistoryData, setOfferRequestHistoryData] = useState<any[]>([]);
  const rejectionNote = useRef("");
  const statusDetailsRef = useRef({ id: "", status: "", rejectionNote: "",companyId: "", ownerStatus: "", ownerRejectionNote: "", cancellationReason: "", trackNumber: "", quantity: "", ownershipTransferDate: "", assignedTo: ""});
  const [rejectionNoteValue, setNote] = useState<string>("");
  const [cancellationReason, setCancellationReason] = useState<string>("");
  const [selectedWarehouseUser, setSelectedWarehouseUser] = useState<string>("");
  const [show, setShow] = useState(false);
  const handleShow = () => setShow(true);
  const [isOpenEditSection, setOpenEditSection] = useState(false);
  const [isMessageBoxOpen, setMessageBoxOpen] = useState(false);
  const [isOwnerStatusChange, setIsOwnerStatusChange] = useState(false);
  const [viewDetails, setViewDetails] = useState(false);
  const handleViewClose = () => setViewDetails(prev => !prev);
  const [isSeller, setIsSeller] = useState<boolean>(false);
  const [showMessageBox, setShowMessageBox] = useState(false);
  const [unreadGroupsCount, setUnreadGroupsCount] = React.useState<number>(0);
  const [unreadMessageCount, setUnreadMessageCount] = React.useState<number>(0);
  const [isCancelled, setIsCancelled] = useState(false);
  const [trackNumberValue, setTrackNumber] = useState<string>("");
  const [ownershipTransferDateValue, setOwnershipTransferDate] = useState<string>("");
  const [isRejected, setIsRejected] = useState(false);
  const [isInTransit, setIsInTransit] = useState(false);
  const [isInWarehouse, setIsInWarehouse] = useState(false);
  const [warehouseUserList, setWarehouseUserList] = useState([]);  
  const fileInputRef = useRef<HTMLInputElement>(null);
  const [files, setFiles] = useState<File[]>([]);
  const [error, setError] = useState<string>("");
  const [totalAvailableBarrelsCount, setTotalAvailableBarrelsCount] = useState(0);
  const [totalReservedBarrelsCount, setTotalReservedBarrelCount] = useState(0);
  const [isNotEnoughBarrels, setIsNotEnoughBarrels] = useState(false);
  const [isNotSelectedRequiredBarrel, setNotSelectedRequiredBarrel] = useState(false);
  const [isSpinner, setIsSpinner] = useState(false);
  const [viewBarrelSelection, setViewBarrelSelection] = useState(false);
  const handleShowBarrelSelection = () => setViewBarrelSelection(true);
  const [showSameInventoryOrders, setShowSameInventoryOrders] = useState(false);
  const [isInventoryHasMultipleOrders, setInventoryHasMultipleOrders] = useState(true);


  // Dynamic Height Calculation Start

  const [wrapperHeight, setWrapperHeight] = useState(0);
  const wrapperRef = useRef<HTMLDivElement>(null);
  
  const updateWrapperHeight = () => {
    if (wrapperRef.current) {
      setWrapperHeight(wrapperRef.current.clientHeight);
      console.log("Wrapper Height:", wrapperRef.current.clientHeight);
    }
  };
  
  // Run on mount, after layout updates
  useLayoutEffect(() => {
    setTimeout(updateWrapperHeight, 0);
  }, []);
  
  // Run when isLoading changes
  useEffect(() => {
    if (!isLoading) {
      setTimeout(updateWrapperHeight, 0); // Delay to ensure DOM updates
    }
  }, [isLoading]);
  
  // Run on window resize
  useEffect(() => {
    const handleResize = () => updateWrapperHeight();
    window.addEventListener("resize", handleResize);
    
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  
   const [innerHeight, setInnerHeight] = useState(0);
      const innerRef = useRef<HTMLDivElement>(null);
    
      // Function to update height
      const updateHeight = () => {
        if (innerRef.current) {
          setInnerHeight(innerRef.current.clientHeight);
        }
      };
    
      useEffect(() => {
        // Update height on mount and resize
        updateHeight();
        window.addEventListener("resize", updateHeight);
        
        return () => {
          window.removeEventListener("resize", updateHeight);
        };
      }, []);
      // Recalculate height when the message box visibility changes
      useEffect(() => {
        if (showMessageBox) {
          // Wait for DOM to update (small delay ensures correct height calculation)
          setTimeout(updateHeight, 0);
        }
      }, [showMessageBox]); // Runs every time showMessageBox changes

      // Dynamic Height Calculation End


  const handleClose = () => {
    setShow(false);
    setIsCancelled(false);
    setCancellationReason('');
    setError("");
    setNote("");
    setTrackNumber("");
    setOwnershipTransferDate("");
    setSelectedWarehouseUser("");
    setIsRejected(false);
    setIsInTransit(false);
    setFiles([]);
  };
  

  const handleCloseBarrelSelection = () => {
    setViewBarrelSelection(false);

    fetchTotalAvailableBarrelCount(offerRequest?.inventoryId);
    fetchTotalReservedBarrelCount();
  }

  const handleWarehouseUserChange = (selectedOption) => {
    setError("");
    setSelectedWarehouseUser(selectedOption ? selectedOption.value : '');
  };

  // Define the localeText object based on the isLoading flag
  const localeText = {
    noRowsLabel: isLoading ? "Fetching records ..." : "No Record Found",
  };

  const routeBack = () => {
    if (
      history.action === "PUSH" ||
      history.action === "REPLACE" ||
      (location.state && (location.state as any).fromInternal)
    ) {
      history.goBack();
    } else {
      if (CommonService.isUser()) history.push("/user/offer-request");
      else if (CommonService.isWarehouse()) history.goBack();
      else if(document.referrer.includes('/master/all-request')) history.goBack();
      else history.push("/master/offer-request");
    }
  };

  //  Initial data fetching on component load
  useEffect(() => {
    const initializeData = async () => {
      await fetchData();
      
      if (CommonService.isAdmin()) {
        await getAdminUnreadMessageGroupsCount();
      }

    const handleClickOutside = () => {
      setShowSameInventoryOrders(false)// Close showing same orders when clicking anywhere outside
    };

    document.addEventListener("click", handleClickOutside);
      return () => {
          document.removeEventListener("click", handleClickOutside);
      };
    };

    initializeData();
  }, []);


  //Fetches all required data for the offer request
  const fetchData = async () => {
    try {
      fetchOfferRequestDetail();
      fetchOfferRequestDocs();
      fetchOfferRequestHistory();
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  //check inventory has multiple orders or not
  const checkMultipleOrders = async (inventoryId: any, requestId:any) => {
    try {
        const response = await OrderApiService.inventoryHasMultipleOrders(inventoryId,requestId);
        setInventoryHasMultipleOrders(response.data);
      } catch (error) {
        console.error("Error checking multiple orders:", error);
      }
  };


   /**
   * Fetches detailed information about the offer request
   * Also handles setting up seller status and barrel counts for admins
   */
   const fetchOfferRequestDetail = async () => {
    setIsLoading(true);
    try {
      const response = await OrderApiService.fetchOfferRequestById(id);
      

      // Determine if current user is the seller
      const hasSeller = CommonService.isSameCompany(response.data?.inventoryOwnerCompanyId) && 
                       CommonService.isUser();
      setIsSeller(hasSeller);

      // Handle admin-specific data fetching
      if (CommonService.isAdmin() || CommonService.isWarehouse()) {
        await fetchTotalAvailableBarrelCount(response?.data?.inventoryId);
        
        const isNotReviewStatus = response?.data?.status !== "PENDING_REVIEW" && 
                                 response?.data?.status !== "UNDER_REVIEW";
        if (isNotReviewStatus) {
          await fetchTotalReservedBarrelCount();
        }
        
        checkMultipleOrders(response.data?.inventoryId, response.data?.id);

      }

      //now set the data in offer request 
      setOfferRequest(response.data);
    } catch (error) {
      console.error('Error fetching offer request details:', error);
    } finally {
      setIsLoading(false);
    }
  };

  // Fetches the total available barrel count for a given group
  const fetchTotalAvailableBarrelCount = async (inventoryId: string) => {
    setIsSpinner(true);
    try {
      const response = await InventoryApiService.getAllBarrelsCount(inventoryId);
      setTotalAvailableBarrelsCount(response?.data);
    } catch (error) {
      console.error('Error fetching available container count:', error);
    } finally {
      setIsSpinner(false);
    }
  };

  //Fetches the total reserved barrel count
  const fetchTotalReservedBarrelCount = async () => {
    setIsSpinner(true);
    try {
      const response = await OrderApiService.getReservedBarrelsCountForOfferRequest(id);
      setTotalReservedBarrelCount(response?.data);
    } catch (error) {
      console.error('Error fetching reserved container count:', error);
    } finally {
      setIsSpinner(false);
    }
  };

  const fetchOfferRequestDocs = async () => {
    const response: any = await OrderApiService.fetchOfferRequestDocs(id);
    setOfferRequestDocs(response.data);
  };

  const fetchOfferRequestHistory = async () => {
    const response: any = await OrderApiService.fetchOfferRequestHistory(id);
    setOfferRequestHistoryData(response.data);
  };

  const getAdminUnreadMessageGroupsCount = async () => {
    try {
      const response = await MessageApiService.getAdminMessageGroups(id, "OFFER_REQUEST");

      setUnreadGroupsCount(response.data.unreadGroupsCount);
      setUnreadMessageCount(response.data.unreadMessageCount);
    } catch (error) {
      console.log("error fetching Admin Message Groups Count" + error);
    }
  }

  //handle edit button click
  const handleEditButtonClick = () => {
    if (isOpenEditSection) {
      setOpenEditSection(false);
    } else {
      setMessageBoxOpen(false);
      setOpenEditSection(true);
    }
  };

  const handleDeleteFile = (indexToDelete: number) => {
    setFiles((prevFiles) =>
      prevFiles.filter((_, index) => index !== indexToDelete)
    );
  };

  //handle message box click
  const handleMessageBoxClick = () => {
    if (isMessageBoxOpen) {
      setMessageBoxOpen(false);
    } else {
      setOpenEditSection(false);
      setMessageBoxOpen(true);
      updateHeight();
      updateWrapperHeight();
    }
  };

  const handleAdminMessageClick = () => {
    setShowMessageBox(prev => !prev);
    updateHeight();
      updateWrapperHeight();

    // Reset unread groups count when the message box is toggled
    setUnreadGroupsCount(unreadGroupsCount > 0 && unreadMessageCount > 0 ? unreadGroupsCount - 1 : unreadGroupsCount);
  };

  const downloadOfferRequestDOC = async (item: any) => {
    const requestDto = {
      id: item.id,
      siteId: offerRequest.siteId,
      companyId: item.companyId,
      fileName: item.fileName,
      requestNumber: offerRequest?.requestNumber
    };

    try {
      const response: any = await OrderApiService.downloadOfferRequestDOC(
        requestDto
      );
      // Assuming response.data is the blob data
      const blob = new Blob([response.data]);
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.style.display = "none";
      a.href = url;
      a.download = item.fileName;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  //formate the status
  function formatStatus(status?: string): string {
    let formattedStatus = "";
    if (status !== undefined) {
      formattedStatus = status
        ?.split(/[_\\]/)
        .map(
          (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
        )
        .join(" ");
    }

    return formattedStatus;
  }


 

  const handleStatusChange = async (newStatus: string) => {

    const orderStatus = newStatus?.replace(/ /g, "_");

    //create the object to send
    const sd = {
      id: id,
      status: orderStatus.toUpperCase(),
      rejectionNote: rejectionNote.current,
      companyId: CommonService.getCompanyId(),
      ownerStatus:null,
      ownerRejectionNote:null,
      cancellationReason: '',
      trackNumber: '',
      ownershipTransferDate: '',
      quantity: offerRequest?.quantity,
      assignedTo: selectedWarehouseUser
    };

    statusDetailsRef.current = sd;
    if (statusDetailsRef.current.status === Constant.OrderStatus.CANCELLED ) {
      setIsCancelled(true);
      handleShow();
    } else if (statusDetailsRef.current.status === Constant.OrderStatus.REJECTED) {
      setIsRejected(true);
      handleShow();
    } else if (statusDetailsRef.current.status === Constant.OrderStatus.SEND_TO_WAREHOUSE) {
      setIsInWarehouse(true);
      let response = await OrderApiService.fetchAllWarehouseUser();
      setWarehouseUserList(response.data);
      handleShow();
    } else if (statusDetailsRef.current.status === Constant.OrderStatus.IN_TRANSIT) {
      setIsInTransit(true);
      handleShow();
    } else if (["UNDER_REVIEW", "ACCEPTED", "IN_PROGRESS", "CONTRACT_SENT", "CONTRACT_EXECUTED", "INVOICE_SENT", "PAYMENT_RECEIVED", "OWNERSHIP_TRANSFERRED", "CLOSED"].includes(statusDetailsRef.current.status)) {
      setIsCancelled(false);
      setIsRejected(false);
      setIsInWarehouse(false);
      setIsInTransit(false);
      handleShow();
    }
    else {
      await changeOfferStatus();
      fetchOfferRequestHistory();
    }
  };


  const changeOfferStatus = async () => {

    if (statusDetailsRef.current.status === Constant.OrderStatus.REJECTED && rejectionNoteValue.trim().length === 0) {
      setError("Please enter rejection note");
      return;
    } else if (statusDetailsRef.current.status === Constant.OrderStatus.REJECTED && rejectionNoteValue.trim().length > 500) {
      setError("Rejection note can not be more than 500 characters");
      return;
    } else if(statusDetailsRef.current.status === Constant.OrderStatus.IN_TRANSIT && trackNumberValue.trim().length === 0) {
      setError("Please enter tracking number");
      return ;
    } else if(statusDetailsRef.current.status === Constant.OrderStatus.SEND_TO_WAREHOUSE && selectedWarehouseUser == "") {
      setError("Please Select Warehouse");
      return;
    } else if (statusDetailsRef.current.status === Constant.OrderStatus.OWNERSHIP_TRANSFERRED) {
        if(ownershipTransferDateValue.trim().length === 0){
          setError("Please enter date of transfer");
          return;
        }
  
        const transferDate = new Date(ownershipTransferDateValue);
        const today = new Date(CommonService.getTodayInTimeZone());
        today.setHours(0, 0, 0, 0);
        transferDate.setHours(0, 0, 0, 0);
  
        if (transferDate < today) {
          setError("Ownership transfer date cannot be in the past.");
          return;
        }
    }

    setIsLoading(true);

    //to prevent to reflect the data in ui 
    if(statusDetailsRef.current.status == Constant.OrderStatus.ACCEPTED) {
      setIsSpinner(true);
    }
    
    try {
      statusDetailsRef.current.rejectionNote = rejectionNote.current;
      statusDetailsRef.current.cancellationReason = cancellationReason;
      statusDetailsRef.current.trackNumber = trackNumberValue;
      statusDetailsRef.current.ownershipTransferDate = ownershipTransferDateValue;
      statusDetailsRef.current.companyId = CommonService.getCompanyId();
      statusDetailsRef.current.assignedTo = selectedWarehouseUser;
      
      const response = await OrderApiService.changeOfferStatus(statusDetailsRef.current);


      if (statusDetailsRef.current.status === Constant.OrderStatus.IN_TRANSIT
        && (files.length > 0)) {
       uploadOfferRequestDocs();
     }
      
      CommonService.Toast.fire({
        title: "Offer Request updated successfully",
        icon: "success",
      });

    } catch (error) {

      const errorMessage = error?.response?.data?.errorMessage ?? "";

      if (errorMessage.includes("Not enough container available for reservation for Offer Request")) {
        setIsNotEnoughBarrels(true);
        CommonService.Toast.fire({
          title: "Out of Stock, please change quantity",
          icon: "error",
        });
      }

      if (errorMessage.includes("Please select the required quantity")) {
        setNotSelectedRequiredBarrel(true);
        CommonService.Toast.fire({
          title: "Please select the container to match the quantity",
          icon: "error",
        });
      }
    } finally {
      await fetchData();
      handleClose();
      setIsLoading(false);
      setIsSpinner(false);
    }
  };


  const handleButtonClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const uploadOfferRequestDocs = async () => {
  
      const formData = new FormData();
      let response;
      let offerRequestDoc = {};
  
      if (files && Array.isArray(files)) {
        files.forEach(function (file: any) {
          formData.append("file", file);
        });
      }
  
      const fileNames = files.map((file) => file.name).join(", ");
  
      offerRequestDoc = {
        offerRequestId: id,
        description: "uploaded " + fileNames + " document",
        userId: CommonService.getUserId(),
        title: fileNames,
        companyId: CommonService.getCompanyId(),
      };
  
      formData.append(
        "param",
        new Blob([JSON.stringify(offerRequestDoc)], {
          type: "application/json",
        })
      );
  
      response = await OrderApiService.uploadOfferRequestDocs(formData);
  
      fetchOfferRequestDocs();
    };

  const handleOwnerStatusChange = async (newStatus: string) => {

    let updatedStatus;

    if (newStatus === "Reject for Owner")
      updatedStatus = "Admin Rejected";
    else if (newStatus === "Accept for Owner")
      updatedStatus = "Admin Accepted";
    else if (newStatus === "Send to Owner")
      updatedStatus = "Pending Review";
    else
      updatedStatus = newStatus;    

    const status = updatedStatus?.replace(/ /g, "_");

    const details = {
        id: id,
        status:null,
        rejectionNote:null,
        ownerStatus: status.toUpperCase(),
        ownerRejectionNote: rejectionNote.current,
        companyId: CommonService.getCompanyId(),
        cancellationReason: '',
        trackNumber: '',
        ownershipTransferDate: '',
        quantity: offerRequest?.quantity,
        assignedTo: selectedWarehouseUser
    };

    statusDetailsRef.current = details;
    if (statusDetailsRef.current.ownerStatus === Constant.OrderStatus.REJECTED || statusDetailsRef.current.ownerStatus === Constant.OrderStatus.ADMIN_REJECTED) {
        setIsOwnerStatusChange(true); // to call method of order item status change
        handleShow();
    } else {
        changeOwnerStatus();
    }
  };

  const changeOwnerStatus = async () => {

    if((statusDetailsRef.current.ownerStatus === Constant.OrderStatus.REJECTED || statusDetailsRef.current.ownerStatus === Constant.OrderStatus.ADMIN_REJECTED) && rejectionNoteValue.trim().length == 0){
      setError("Please enter rejection note");
      return ;
    }

    setIsLoading(true);
    
    try {
      statusDetailsRef.current.ownerRejectionNote = rejectionNote.current;

      await OrderApiService.changeOwnerStatusForOffer(statusDetailsRef.current);
      setIsLoading(false);
      setIsOwnerStatusChange(false); 

      CommonService.Toast.fire({
          title: "Owner status updated successfully",
          icon: "success",
      });

      handleClose();
      fetchOfferRequestDetail();
    } catch (error) {
      setIsLoading(false);
      console.log("error occurred which api calling");
    }
  };

  const handleRejectionNoteChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    setNote(event.target.value);
    setError("");
    rejectionNote.current = event.target.value;
  };

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
      if (event.target.files) {
  
        const newFiles = Array.from(event.target.files);
        setFiles((prevFiles) => [...prevFiles, ...newFiles]);
  
        // Clear the input value to allow selecting the same file again
        event.target.value = "";
      }
    };

  const handleTrackingNumberChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setTrackNumber(event.target.value);
    setError("");
  };

  const dateInputRef = useRef(null);

  const handleDateClick = () => {
    if (dateInputRef.current) {
      dateInputRef.current?.showPicker(); // This will trigger the date picker to open
    }
  };

  const handleOwnershipTransferDateChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setOwnershipTransferDate(event.target.value);
    setError("");
  };

  const handleCancellationReasonChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    setCancellationReason(event.target.value);
    setError("");
  };

  const columnsForDoc: GridColDef[] = [
    {
      field: "createdDate",
      headerName: "Submitted On",
      flex: 1,
      minWidth:140,
      valueGetter: (value: any, row: any) => {
        const dateTimeString = row.createdDate ? row.createdDate : null;
        if (dateTimeString) {
          //call the method which formate the time
          return CommonService.formatDateTime(dateTimeString);
        }
      },
      headerClassName: "table-header",
    },
    {
      field: "fileName",
      headerName: "File Name",
      flex: 1,
      minWidth:140,
      valueGetter: (value: any, row: any) => {
        const fullFileName = row.fileName || "";
        const fileNameAfterFirstUnderscore = fullFileName.split('_').slice(1).join('_');
        return fileNameAfterFirstUnderscore || fullFileName;
      },
      headerClassName: "table-header",
      renderCell: (params) => <CellWithTooltip value={params.value} />,
    },
    {
      field: "user",
      headerName: "Submitted By",
      flex: 1,
      minWidth:140,
      valueGetter: (value: any, row: any) =>
        `${row.firstName || ""} ${row.lastName || ""}`,
      headerClassName: "table-header",
      renderCell: (params) => <CellWithTooltip value={params.value} />,
    },
    {
      field: "action",
      headerName: "Action",
      flex: 1,
      minWidth:140,
      sortable: false,
      width: 200,
      headerClassName: "table-header",
      renderCell: (params: any) => {

        //check file have .pdf extension or not
        const isPdf = params.row.fileName.toLowerCase().endsWith(".pdf");

        return (
        <div>

           {isPdf && (
                        <Tooltip title="View PDF" arrow>
                          <IconButton
                            onClick={() =>
                              CommonService.showPdf(
                                params.row.id,
                                params.row.companyId,
                                offerRequest.siteId,
                                params.row.fileName,
                                Constant.RequestType.OFFER_REQUEST,
                                offerRequest?.requestNumber,
                              )
                            }
                          >
                            <VisibilityOutlined />
                          </IconButton>
                        </Tooltip>
                      )}
          <Tooltip title="Download document" arrow>
            <IconButton
              onClick={(event) => downloadOfferRequestDOC(params.row)}
            >
              {/* <CloudDownloadOutlinedIcon /> */}
              <img className="cursor-pointer" 
                          src={DownLoadIcon}
                          alt="EditIcon"
                        />
            </IconButton>
          </Tooltip>
        </div>
      );
    }
    },
  ];

  const CellWithTooltip = ({ value }: { value: string | number }) => {
    return (
      <Tooltip arrow title={value?.toString()}>
        <span>{value?.toString()}</span>
      </Tooltip>
    );
  };

  function getStatusForSeller(status: string): string {
    
    switch (status) {
      case "ACCEPTED":
      case "ADMIN_ACCEPTED":
        return "ACCEPTED";
  
      case "REJECTED":
      case "ADMIN_REJECTED":
        return "REJECTED";
  
      case "ACTION_REQUIRED":
      case "PENDING_REVIEW":
        return "PENDING_REVIEW";
  
      default:
        return ""; // or a default status like "UNKNOWN"
    }
  }
  

  return (
    <>
      <div className="usersList position-relative">

        <div className="usersList__header--wrapper detail-page-header--wrapper d-flex">
          {(CommonService.isAdmin() || CommonService.isWarehouse()) && (
            <div className="usersList__header--inner d-flex justify-content-between gap-4">
              <div className="d-flex align-items-center gap-1">
              <div className="back__button me-1" onClick={routeBack}>
                <IconButton
                  aria-label="ArrowBackIcon"
                  sx={{ backgroundColor: "#FFF" }}
                >
                  <ArrowBackIcon sx={{ color: "#1C1B1F" }} />
                </IconButton>
              </div>
              <div className="header--title me-3">
                <h1 className="title mb-0 text-nowrap">
                  Offer Request Details
                  <i className="bi bi-heart-fill"></i>
                </h1>
              </div>
            </div>
          </div>)}
          <div className="d-flex align-items-center flex-column flex-lg-row justify-content-lg-between w-100 gap-2 gap-lg-0">
          <div className="header--title d-flex flex-wrap me-auto mb-xxl-0 gap-2 gap-xxl-3">
          <div className="time__details me-3 me-xl-4 mb-0">
              <Typography
                variant="h6"
                sx={{ color: "#333333", fontSize: "12px", fontWeight: 400 }}
              >
                Request number
              </Typography>
              <Typography
                variant="h3"
                sx={{ color: "#333333", fontSize: "18px", fontWeight: 700 }}
              >
                #{offerRequest?.requestNumber}
              </Typography>
            </div>
            {(CommonService.isSameCompany(offerRequest?.companyId) ||
              CommonService.isAdmin()) && (
              <>
                {" "}
                {CommonService.isAdmin() && (<div className="company__details me-3 me-xl-4 mb-0">
                  <Typography
                    variant="h6"
                    sx={{ color: "#333333", fontSize: "12px", fontWeight: 400 }}
                  >
                    Account Owner name
                  </Typography>
                  <Typography
                    variant="h3"
                    sx={{
                      color: "#333333",
                      fontSize: { xl: "18px", xs: "16px" },
                      fontWeight: 700,
                    }}
                  >
                    {offerRequest?.companyName}
                  </Typography>
                </div>)}
                <div className="person__details me-3 me-xl-4 mb-0">
                  <Typography
                    variant="h6"
                    sx={{ color: "#333333", fontSize: "12px", fontWeight: 400 }}
                  >
                    Requested by
                  </Typography>
                  <Typography
                    variant="h3"
                    sx={{ color: "#333333", fontSize: "18px", fontWeight: 700 }}
                  >
                    {offerRequest?.firstName } {offerRequest?.lastName}
                  </Typography>
                </div>
              </>
            )}
            <div className="time__details me-3 me-xl-4 mb-0">
              <Typography
                variant="h6"
                sx={{ color: "#333333", fontSize: "12px", fontWeight: 400 }}
              >
                Requested on
              </Typography>
              <Typography
                variant="h3"
                sx={{ color: "#333333", fontSize: "18px", fontWeight: 700 }}
              >
                { !isSeller ? CommonService.formatDateTime(offerRequest?.createdDate) 
                            : CommonService.formatDateTime(offerRequestHistoryData[offerRequestHistoryData.length - 1]?.histories[offerRequestHistoryData[offerRequestHistoryData.length - 1].histories.length - 1]?.createdDate)}
             
              </Typography>
            </div>

            {( offerRequest?.trackNumber && !isSeller &&
            <div className="time__details me-3 me-xl-4 mb-0">
              <Typography
                variant="h6"
                sx={{ color: "#333333", fontSize: "12px", fontWeight: 400 }}
              >
                Track Number
              </Typography>
              <Typography
                variant="h3"
                sx={{ color: "#333333", fontSize: "18px", fontWeight: 700 }}
              >
                {offerRequest?.trackNumber}
              </Typography>
            </div>)}

            {offerRequest?.ownershipTransferDate && !isSeller && (
                <div className="time__details me-3 me-xl-4 mb-0">
                  <Typography
                    variant="h6"
                    sx={{ color: "#333333", fontSize: "12px", fontWeight: 400 }}
                  >
                    Date of transfer
                  </Typography>
                  <Typography
                    variant="h3"
                    sx={{ color: "#333333", fontSize: "18px", fontWeight: 700 }}
                  >
                    {offerRequest?.ownershipTransferDate}
                  </Typography>
                </div>
            )}
            <div className="time__details me-3 me-xl-4 mb-0">
              <Typography
                    variant="h6"
                    sx={{ color: "#333333", fontSize: "12px", fontWeight: 400 }}
                  >
                    Status
                  </Typography>
                  <Typography
                    variant="h3"
                    sx={{ color: "#333333", fontSize: "18px", fontWeight: 700 }}
                  >
                    {isSeller && CommonService.isUser() && (

              <StatusDropdown
              currentStatus={formatStatus(getStatusForSeller(offerRequest?.ownerStatus))}
              onStatusChange={(newStatus) => handleStatusChange(newStatus)}
              disableCondition={true}
              allowedLabels={[]}
            />
            )}

              {(!isSeller && (offerRequest?.status === "PENDING_REVIEW" || offerRequest?.status === "UNDER_REVIEW")) && (
                <StatusDropdown
                  currentStatus={formatStatus(offerRequest?.status)}
                  onStatusChange={(newStatus) => handleStatusChange(newStatus)}
                  disableCondition={((!CommonService.isSameCompany(offerRequest?.companyId) && CommonService.isUser()) || (!CommonService.isSameUser(offerRequest?.createdBy) && CommonService.isSameCompany(offerRequest?.companyId) && CommonService.getRole() === Constant.Role.USER))}
                  allowedLabels={CommonService.isUser() ? ["Cancelled"] : (offerRequest?.hasValidStatus ? ["Under Review", "Rejected"] : offerRequest?.hasItemRejected ? ["Under Review", "Rejected"] : ["Under Review", "Accepted", "Rejected"])}
                />
              )}

              {/* Accepted to Payment Received - Both User and Admin */}
              {(!isSeller && ["ACCEPTED", "IN_PROGRESS", "CONTRACT_SENT", "INVOICE_SENT", "CONTRACT_EXECUTED", "PAYMENT_RECEIVED"].includes(offerRequest?.status)) && (
                <StatusDropdown
                  currentStatus={formatStatus(offerRequest?.status)}
                  onStatusChange={(newStatus) => handleStatusChange(newStatus)}
                  disableCondition={((!CommonService.isSameCompany(offerRequest?.companyId) && CommonService.isUser()) || (!CommonService.isSameUser(offerRequest?.createdBy) && CommonService.isSameCompany(offerRequest?.companyId) && CommonService.getRole() === Constant.Role.USER))}
                  allowedLabels={CommonService.isAdmin() ? ["Contract Sent", "Contract Executed", "Invoice Sent", "Payment Received", "In Progress", "Ownership Transferred", "Rejected"] : ["Cancelled"]}
                />
              )}

              {!isSeller && (offerRequest?.status === "OWNERSHIP_TRANSFERRED") && (
                <StatusDropdown
                  currentStatus={formatStatus(offerRequest?.status)}
                  onStatusChange={(newStatus) => {
                    handleStatusChange(newStatus);
                  }}
                  disableCondition={CommonService.isWarehouse() || CommonService.isUser()}
                  allowedLabels={[
                    "Send to Warehouse"
                  ]}
                />
              )}

              {!isSeller && ["SEND_TO_WAREHOUSE", "IN_PROCESS"].includes(offerRequest?.status) && (
                <StatusDropdown
                  currentStatus={formatStatus(offerRequest?.status)}
                  onStatusChange={(newStatus) => {
                    handleStatusChange(newStatus);
                  }}
                  disableCondition={CommonService.isUser()}
                  allowedLabels={
                    CommonService.isAdmin()
                      ? [
                        "Admin Accepted for Warehouse"
                      ]
                      : [
                        "In Process",
                        "Reassign to Admin",
                        "Warehouse Completed"
                      ]
                  }
                />
              )}

              {!isSeller && ["ADMIN_ACCEPTED_FOR_WAREHOUSE", "REASSIGN_TO_ADMIN", "WAREHOUSE_COMPLETED"].includes(offerRequest?.status) && (
                <StatusDropdown
                  currentStatus={formatStatus(offerRequest?.status)}
                  onStatusChange={(newStatus) => {
                    handleStatusChange(newStatus);
                  }}
                  disableCondition={CommonService.isUser() || CommonService.isWarehouse()}
                  allowedLabels={[
                    ...(offerRequest?.status === "REASSIGN_TO_ADMIN") ? ["Send to Warehouse"] : [],
                    ...(offerRequest?.inventory?.isRelocationRequired || offerRequest.isRelocationRequired) ? ["In Transit"]: [],
                     "Closed"]}
                />
              )}

              {!isSeller && (offerRequest?.status === "IN_TRANSIT") && (
                <StatusDropdown
                  currentStatus={formatStatus(offerRequest?.status)}
                  onStatusChange={(newStatus) => {
                    handleStatusChange(newStatus);
                  }}
                  disableCondition={CommonService.isWarehouse() || CommonService.isUser()}
                  allowedLabels={["Closed"]}
                />
              )}

              {!isSeller && (offerRequest?.status === "REJECTED" || offerRequest?.status === "CLOSED") && (
                  <StatusDropdown
                    currentStatus={formatStatus(offerRequest?.status)}
                    onStatusChange={(newStatus) => {
                      handleStatusChange(newStatus);
                    }}
                    disableCondition={true}
                    allowedLabels={[]}
                  />
                )}

              {!isSeller && (offerRequest?.status === "CANCELLED") && (
                  <StatusDropdown
                    currentStatus={formatStatus(offerRequest?.status)}
                    onStatusChange={(newStatus) => {
                      handleStatusChange(newStatus);
                    }}
                    disableCondition={CommonService.isWarehouse() || CommonService.isUser()}
                    allowedLabels={['Closed']}
                  />
                )}

              {!isSeller && offerRequest?.status === "REJECTED" && offerRequest?.rejectionNote && (
                <Tooltip
                  title={`Rejection Note: ${offerRequest?.rejectionNote}`}
                  arrow
                >
                  <StickyNote2Icon
                    className="note-icon cursor-pointer"
                    style={{ color: "gray" }}
                  />
                </Tooltip>
              )}

              {!isSeller && offerRequest?.status === "CANCELLED" && offerRequest?.cancellationReason && (
                <Tooltip
                  title={`Cancellation Reason: ${offerRequest?.cancellationReason}`}
                  arrow
                >
                  <StickyNote2Icon
                    className="note-icon cursor-pointer"
                    style={{ color: "gray" }}
                  />
                </Tooltip>
              )}
                  </Typography>
            </div>
          </div>
          
          <div className="header--menu ms-auto mb-xxl-0">
            <div className="header--menu-items">
              {!CommonService.isWarehouse() && <IconButton
                aria-label="message"
                size="small"
                onClick={CommonService.isAdmin() ? handleAdminMessageClick : handleMessageBoxClick}
                sx={{
                  borderRadius: "50%",
                  backgroundColor: isMessageBoxOpen ? "#97AEB8" : "#FFF",
                  color: isMessageBoxOpen ? "#FFF" : "#1C1B1F",
                  marginInline: "8px",
                  padding: "8px",
                }}
              >
                <MarkunreadOutlinedIcon />
                {unreadGroupsCount != 0 && CommonService.isAdmin() && <div className="msg-count-wrapper">
                  {unreadGroupsCount}
                </div>}
                {showMessageBox && <ArrowDropUpIcon className="arrow-icon" />}
              </IconButton>}
              {/* {showMessageBox &&
              <div className="admin-message-box">
                <div className="admin-message-box-left-inner" onClick={handleAdminMessageClick}></div>
                <div className="admin-message-box-inner positio-relative">
                  <AdminMessageBox selectedGroup={""} requestId={id} 
                    requestType={"OFFER_REQUEST"} unreadGroupsCount={unreadGroupsCount}
                    setUnreadGroupsCount={setUnreadGroupsCount} isSeller={isSeller} />
                </div>
              </div>
            } */}

            {/* {isSeller && CommonService.isUser() && (

              <StatusDropdown
              currentStatus={formatStatus(getStatusForSeller(offerRequest?.ownerStatus))}
              onStatusChange={(newStatus) => handleStatusChange(newStatus)}
              disableCondition={true}
              allowedLabels={[]}
            />
            )}

              {(!isSeller && (offerRequest?.status === "PENDING_REVIEW" || offerRequest?.status === "UNDER_REVIEW")) && (
                <StatusDropdown
                  currentStatus={formatStatus(offerRequest?.status)}
                  onStatusChange={(newStatus) => handleStatusChange(newStatus)}
                  disableCondition={((!CommonService.isSameCompany(offerRequest?.companyId) && CommonService.isUser()) || (!CommonService.isSameUser(offerRequest?.createdBy) && CommonService.isSameCompany(offerRequest?.companyId) && CommonService.getRole() === Constant.Role.USER))}
                  allowedLabels={CommonService.isUser() ? ["Cancelled"] : (offerRequest?.hasValidStatus ? ["Under Review", "Rejected"] : offerRequest?.hasItemRejected ? ["Under Review", "Rejected"] : ["Under Review", "Accepted", "Rejected"])}
                />
              )} */}

              {/* Accepted to Payment Received - Both User and Admin */}
              {/* {(!isSeller && ["ACCEPTED", "IN_PROGRESS", "CONTRACT_SENT", "INVOICE_SENT", "CONTRACT_EXECUTED", "PAYMENT_RECEIVED"].includes(offerRequest?.status)) && (
                <StatusDropdown
                  currentStatus={formatStatus(offerRequest?.status)}
                  onStatusChange={(newStatus) => handleStatusChange(newStatus)}
                  disableCondition={((!CommonService.isSameCompany(offerRequest?.companyId) && CommonService.isUser()) || (!CommonService.isSameUser(offerRequest?.createdBy) && CommonService.isSameCompany(offerRequest?.companyId) && CommonService.getRole() === Constant.Role.USER))}
                  allowedLabels={CommonService.isAdmin() ? ["Contract Sent", "Contract Executed", "Invoice Sent", "Payment Received", "In Progress", "Ownership Transferred", "Rejected"] : ["Cancelled"]}
                />
              )}

              {!isSeller && (offerRequest?.status === "OWNERSHIP_TRANSFERRED") && (
                <StatusDropdown
                  currentStatus={formatStatus(offerRequest?.status)}
                  onStatusChange={(newStatus) => {
                    handleStatusChange(newStatus);
                  }}
                  disableCondition={CommonService.isUser()}
                  allowedLabels={[...(offerRequest?.inventory?.isRelocationRequired || offerRequest.isRelocationRequired) ? ["In Transit"]: [], "Closed"]}
                />
              )}

              {!isSeller && (offerRequest?.status === "IN_TRANSIT") && (
                <StatusDropdown
                  currentStatus={formatStatus(offerRequest?.status)}
                  onStatusChange={(newStatus) => {
                    handleStatusChange(newStatus);
                  }}
                  disableCondition={CommonService.isUser()}
                  allowedLabels={["Closed"]}
                />
              )}

              {!isSeller && (offerRequest?.status === "REJECTED" || offerRequest?.status === "CLOSED") && (
                  <StatusDropdown
                    currentStatus={formatStatus(offerRequest?.status)}
                    onStatusChange={(newStatus) => {
                      handleStatusChange(newStatus);
                    }}
                    disableCondition={true}
                    allowedLabels={[]}
                  />
                )}

              {!isSeller && (offerRequest?.status === "CANCELLED") && (
                  <StatusDropdown
                    currentStatus={formatStatus(offerRequest?.status)}
                    onStatusChange={(newStatus) => {
                      handleStatusChange(newStatus);
                    }}
                    disableCondition={CommonService.isUser()}
                    allowedLabels={['Closed']}
                  />
                )}

              {!isSeller && offerRequest?.status === "REJECTED" && offerRequest?.rejectionNote && (
                <Tooltip
                  title={`Rejection Note: ${offerRequest?.rejectionNote}`}
                  arrow
                >
                  <StickyNote2Icon
                    className="note-icon cursor-pointer"
                    style={{ color: "gray" }}
                  />
                </Tooltip>
              )}

              {!isSeller && offerRequest?.status === "CANCELLED" && offerRequest?.cancellationReason && (
                <Tooltip
                  title={`Cancellation Reason: ${offerRequest?.cancellationReason}`}
                  arrow
                >
                  <StickyNote2Icon
                    className="note-icon cursor-pointer"
                    style={{ color: "gray" }}
                  />
                </Tooltip>
              )} */}

              {!isSeller && ( (offerRequest?.status === "PENDING_REVIEW" || offerRequest?.status === "UNDER_REVIEW") && (CommonService.isAdmin()
                || (CommonService.isSameCompany(offerRequest?.companyId) && CommonService.getRole() === Constant.Role.ADMIN && offerRequest?.ownerStatus === 'ACTION_REQUIRED')
                || (CommonService.isSameUser(offerRequest?.createdBy) && offerRequest?.ownerStatus === 'ACTION_REQUIRED')))
                && (
                  <Tooltip title="Edit" arrow>
                    <IconButton
                      aria-label="message"
                      size="small"
                      onClick={handleEditButtonClick}
                      sx={{
                        borderRadius: "50%", backgroundColor: isOpenEditSection
                          ? "#97AEB8" // When only `isOpenEditSection` is true
                          : "#fff", color: "#1C1B1F", marginInline: "8px", padding: "8px"
                      }}

                    >
                      {isOpenEditSection
                        ? <img className="cursor-pointer"
                          src={EditIconWhite}
                          alt="EditIconWhite"
                        /> : <img className="cursor-pointer"
                          src={EditIcon}
                          alt="EditIcon"
                        />
                      }


                    </IconButton>
                  </Tooltip>
                )}


            </div>
          </div>
          </div>
        </div>


        <div className="viewSampleRequest--wrapper view_request--wrapper viewOrderRequest--wrapper viewOfferRequest--wrapper" ref={wrapperRef}>
          <div
            className={`${
              isOpenEditSection
              ? "margin-right-400"  // When only `isOpenEditSection` is true
              : isMessageBoxOpen
              ? "margin-right-400"   // Only `isMessageBoxOpen` is true
              : "no-margin"    
            }`}
          >
            <div className="view-sample-request">
              <div className="row m-0">
              <div className="col-12 px-0">
                <div>
                  <div>
                    <div className="inventory-file-list-table">
                        <div className="table-responsive-lg table-responsive-fixed-header">
                          <Table className='orderRequest-inv-table'>
                            <thead>
                              <tr>
                                <th className='text-nowrap text-start'>Inventory</th>
                                
                                  <th colSpan={2} className="text-center text-nowrap">Owner</th>
                                  <th colSpan={2} className="text-center text-nowrap">Buyer</th>
                              
                                <th className='text-nowrap'>Quantity</th>
                                <th className='text-nowrap'>Sell Price</th>
                                <th className='text-nowrap'>Offered Price</th>
                                {isSeller && <th className='text-nowrap'>Commission Fee</th>}
                                {/* { !isSeller &&
                                <th colSpan={2} className="text-center text-nowrap">Fees</th>} */}
                                <th className='text-nowrap'>{!isSeller ? 'Total Price' : 	'Total Proceeds'}</th>
                                {( isSeller || CommonService.isAdmin()) &&
                                <th className='text-nowrap text-center'>Owner Status</th>}
                              </tr>
                              <tr>
                                <th className='text-nowrap text-center'></th>
                               
                                <th className='text-nowrap text-center'>Relocation</th>
                                <th className='text-nowrap text-center'>Cha. of Acc.</th>
                                <th className='text-nowrap text-center'>Relocation</th>
                                <th className='text-nowrap text-center'>Cha. of Acc.</th>
                                
                                <th className='text-nowrap text-center'></th>
                                <th className='text-nowrap text-center'></th>
                                <th className='text-nowrap text-center'></th>
                                {/* { !isSeller &&<>
                                <th className='text-nowrap text-center'>Handling</th>
                                <th className='text-nowrap text-center'>Service</th>
                                </>} */}
                                <th className='text-nowrap text-center'></th>
                                {( isSeller || CommonService.isAdmin()) && <th className='text-nowrap text-center'></th>}
                                { isSeller &&<th className='text-nowrap text-center'></th>}
                              </tr>
                            </thead>
                            <tbody>
                            {offerRequest ? (
                              <tr>
                                <td className="text-start cursor-pointer" onClick={() => {
                                  handleViewClose();
                                }}>
                                  <div className="header d-flex flex-column position-relative">
                                      <span className="inventory-name text-nowrap">{offerRequest?.inventoryName}
                                      {CommonService.isAdmin() && !["REJECTED", "OWNERSHIP_TRANSFERRED","CLOSED", "CANCELLED","IN_TRANSIT"].includes(offerRequest?.status) && isInventoryHasMultipleOrders && (<span className='image-wrapper ms-2' onClick={(event) => {
                                        event.stopPropagation();
                                        setShowSameInventoryOrders(prev => !prev)
                                      }}>
                                           <img src={barrelListCheck} alt="barrel-list"></img>
                                      </span>)}
                                      </span>


                                {CommonService.isAdmin() && (<Typography component="p" sx={{ color: "#737376", fontSize: "13px", fontWeight: "400", lineHeight:"21.28px" }}>
                                    {offerRequest?.inventoryOwnerCompanyName}
                                </Typography>)}

                                {showSameInventoryOrders && (
                                    <div className='position-absolute bottom-0 top-100 start-50' style={{ zIndex: 20 }}>
                                    <SameInventoryOrders inventoryId={offerRequest?.inventoryId} requestId={offerRequest?.id} />
                                    </div>
                                )}
                                </div>
                                </td>
                               
                                <td className='text-nowrap text-center'>
                                  {offerRequest?.inventory?.isRelocationRequired ? (
                                    <>
                                      <CheckIcon fontSize="small" sx={{ color: '#25CD25' }} /> Yes
                                    </>
                                  ) : (
                                    <>
                                      <CloseIcon fontSize="small" sx={{ color: '#FF3B30' }} /> No
                                    </>
                                  )}
                                </td>
                                <td className='text-nowrap text-center'>
                                  {offerRequest?.inventory?.isAccountTransfer ? (
                                    <>
                                      <CheckIcon fontSize="small" sx={{ color: '#25CD25' }} /> Yes
                                    </>
                                  ) : (
                                    <>
                                      <CloseIcon fontSize="small" sx={{ color: '#FF3B30' }} /> No
                                    </>
                                  )}
                                </td>
                                <td className='text-nowrap text-center'>
                                  {offerRequest?.isRelocationRequired ? (
                                    <>
                                      <CheckIcon fontSize="small" sx={{ color: '#25CD25' }} /> Yes
                                    </>
                                  ) : (
                                    <>
                                      <CloseIcon fontSize="small" sx={{ color: '#FF3B30' }} /> No
                                    </>
                                  )}
                                </td>
                                <td className='text-nowrap text-center'>
                                  {offerRequest?.isAccountTransfer ? (
                                    <>
                                      <CheckIcon fontSize="small" sx={{ color: '#25CD25' }} /> Yes
                                    </>
                                  ) : (
                                    <>
                                      <CloseIcon fontSize="small" sx={{ color: '#FF3B30' }} /> No
                                    </>
                                  )}
                                </td>

                                <td className={`text-nowrap ${!totalAvailableBarrelsCount < offerRequest?.quantity && "pb-4"}`}>
                                  <div className="position-relative">
                                    {offerRequest?.quantity} container
                                    <>

                                      {CommonService.isAdmin() && !isSpinner && !['REJECTED', 'CANCELLED', 'CLOSED', 'IN_TRANSIT', 'OWNERSHIP_TRANSFERRED'].includes(offerRequest?.status) && (
                                        <Tooltip
                                          arrow
                                          title={`${Intl.NumberFormat().format(totalAvailableBarrelsCount + totalReservedBarrelsCount)} ${(totalAvailableBarrelsCount + totalReservedBarrelsCount) > 1 ? 'Containers' : 'Container'} in Stock`}
                                        >
                                          <span
                                            className="available-barrels-count ms-2"
                                            style={{
                                              backgroundColor: ((totalAvailableBarrelsCount + totalReservedBarrelsCount) < offerRequest?.quantity && totalReservedBarrelsCount !== offerRequest?.quantity) ? "#C7858B" : "#75BC84"
                                            }}
                                          >
                                            {(totalAvailableBarrelsCount + totalReservedBarrelsCount) >= 10000 ? "9,999+" : Intl.NumberFormat().format(totalAvailableBarrelsCount + totalReservedBarrelsCount)}
                                          </span>
                                        </Tooltip>
                                      )}

                                      {(CommonService.isAdmin() || CommonService.isWarehouse()) && !isSpinner &&
                                        !['REJECTED', 'CANCELLED', 'PENDING_REVIEW', 'UNDER_REVIEW'].includes(offerRequest?.status) && (
                                          <div>
                                            <>
                                              {totalAvailableBarrelsCount >= offerRequest?.quantity &&
                                                totalReservedBarrelsCount === 0 && (
                                                  <button
                                                    onClick={handleShowBarrelSelection}
                                                    className="reserve-barrel-btn ps-0"
                                                    style={{ marginLeft: "-4px" }}
                                                  >
                                                    <AddSharpIcon /> Reserve
                                                  </button>
                                                )}

                                              {totalReservedBarrelsCount > 0 && (
                                                <button
                                                  onClick={handleShowBarrelSelection}
                                                  className="reserve-barrel-btn ps-0"
                                                >
                                                  {totalReservedBarrelsCount} Reserved
                                                </button>
                                              )}
                                            </>
                                          </div>
                                        )}

                                      {/* {(totalAvailableBarrelsCount+totalReservedBarrelsCount) < offerRequest?.quantity && !isSpinner && 
      isNotEnoughBarrels && 
      CommonService.isAdmin() && (
        <span 
          className="barrel-error" 
          style={{
            bottom: totalAvailableBarrelsCount > 0 ? "-20px" : "-30px"
          }}
        >
          <WarningIcon /> Out of Stock, please change quantity.
        </span>
    )}

  {(totalAvailableBarrelsCount < offerRequest?.quantity || totalReservedBarrelsCount < offerRequest?.quantity) && !isSeller && 
      isNotSelectedRequiredBarrel && 
      CommonService.isAdmin() && (
        <span 
          className="barrel-error" 
          style={{
            bottom: totalAvailableBarrelsCount > 0 ? "-20px" : "-30px"
          }}
        >
          <WarningIcon /> Please select a number of items equal to the specified quantity.
        </span>
    )} */}

                                      {(totalAvailableBarrelsCount + totalReservedBarrelsCount) < offerRequest?.quantity && !isSpinner &&
                                        isNotEnoughBarrels &&
                                        (CommonService.isAdmin() || CommonService.isWarehouse()) && (
                                          <span
                                            className="barrel-error"
                                            style={{
                                              bottom: totalAvailableBarrelsCount >= 0 ? "-40px" : "-25px"
                                            }}
                                          >
                                            <WarningIcon /> Out of Stock, please change quantity.
                                          </span>
                                        )}

                                      {(totalAvailableBarrelsCount < offerRequest?.quantity || totalReservedBarrelsCount < offerRequest?.quantity) &&
                                        isNotSelectedRequiredBarrel && !isSpinner &&
                                        (CommonService.isAdmin() || CommonService.isWarehouse()) && (
                                          <span
                                            className="barrel-error"
                                            style={{
                                              bottom: totalAvailableBarrelsCount > 0 ? "-22px" : "-25px"
                                            }}
                                          >
                                            <WarningIcon />Please select a number of items equal to the specified quantity.
                                          </span>
                                        )}
                                    </>
                                  </div>
                                </td>

                                <td className='text-nowrap'>
                                  <CurrencyFormatter
                                    amount={offerRequest?.inventory?.price}
                                    locale="en-US"
                                    currency="USD"
                                  />
                                  <p className="per-barrel-text">per container</p>
                                </td>

                                <td className='text-nowrap'>
                                  <CurrencyFormatter
                                    amount={offerRequest?.pricePerBarrel}
                                    locale="en-US"
                                    currency="USD"
                                  />
                                  <p className="per-barrel-text">per container</p>
                                </td>

                                {isSeller && (
                                <td>
                                  {offerRequest?.inventory?.feeType === 'PERCENTAGE' ? (
                                    <>
                                      (
                                      <CurrencyFormatter
                                        amount={(offerRequest?.pricePerBarrel * offerRequest?.inventory?.fee) / 100}
                                        locale="en-US"
                                        currency="USD"
                                      />
                                      
                                      )
                                      <p className="per-barrel-text">per container</p>
                                    </>
                                  ) : (
                                    <>
                                      (
                                      <CurrencyFormatter
                                        amount={offerRequest?.inventory?.fee}
                                        locale="en-US"
                                        currency="USD"
                                      />
                                      
                                      )
                                      <p className="per-barrel-text">per container</p>
                                    </>
                                    
                                  )}
                                </td>
                              )}


                                {/* { !isSeller && <>
                                <td className='text-nowrap text-center'><CurrencyFormatter
                                  amount={offerRequest?.handlingFee/offerRequest?.quantity}
                                  locale="en-US"
                                  currency="USD"
                                />
                                <p className="per-barrel-text">per container</p>
                                </td>
                                <td className='text-nowrap text-center'>
                                  <CurrencyFormatter
                                    amount={offerRequest?.serviceFee/offerRequest?.quantity}
                                    locale="en-US"
                                    currency="USD"
                                  />
                                <p className="per-barrel-text">per container</p>  
                                </td>
                                </>} */}

                                  <td className='text-nowrap'>
                                  <CurrencyFormatter
                                    amount={
                                      !isSeller
                                        ? offerRequest?.totalAmount // When not a seller, use the total amount
                                        : (
                                          // When a seller, deduct handling fees, service fees, and platform fee (based on fee type)
                                          offerRequest?.totalAmount
                                          - (offerRequest?.handlingFee + offerRequest?.serviceFee)
                                          - (
                                            offerRequest?.quantity * (offerRequest?.inventory?.feeType === 'PERCENTAGE'
                                              ? (offerRequest?.pricePerBarrel * offerRequest?.inventory?.fee) / 100
                                              : offerRequest?.inventory?.fee)
                                          )
                                        )
                                    }
                                    locale="en-US"
                                    currency="USD"
                                  />
                                </td>


                                {(isSeller || CommonService.isAdmin()) && <> 
                                <td className='text-nowrap text-center'>
                                  {CommonService.isAdmin() && <StatusDropdown currentStatus={formatStatus(offerRequest?.ownerStatus)}
                                        onStatusChange={(newStatus) =>
                                          handleOwnerStatusChange(newStatus)
                                        }
                                        disableCondition={CommonService.isSameCompany(offerRequest?.companyId) || ["REJECTED", "ADMIN_REJECTED", "ACCEPTED"].includes(offerRequest?.ownerStatus)
                                            || ["ACCEPTED", "REJECTED", "IN_PROGRESS", "CONTRACT_SENT", "CONTRACT_EXECUTED", "INVOICE_SENT", "PAYMENT_RECEIVED", "OWNERSHIP_TRANSFERRED", "IN_TRANSIT", "CANCELLED", "CLOSED"].includes(offerRequest?.status)
                                        }
                                        allowedLabels={(offerRequest?.ownerStatus === "ADMIN_ACCEPTED") ? ["Reject for Owner"] 
                                                        : offerRequest?.ownerStatus === "PENDING_REVIEW" ? ["Accept for Owner", "Reject for Owner"] 
                                                        :["Send to Owner", "Accept for Owner", "Reject for Owner"]}/>}
                                  
                                  {CommonService.isUser() && <StatusDropdown currentStatus={formatStatus(offerRequest?.ownerStatus)}
                                            onStatusChange={(newStatus) =>
                                              handleOwnerStatusChange(newStatus)
                                            }
                                            disableCondition={CommonService.isSameCompany(offerRequest?.companyId) || ["REJECTED", "ADMIN_REJECTED"].includes(offerRequest?.ownerStatus)
                                                || ["ACCEPTED", "REJECTED", "IN_PROGRESS", "CONTRACT_SENT", "CONTRACT_EXECUTED", "INVOICE_SENT", "PAYMENT_RECEIVED", "OWNERSHIP_TRANSFERRED", "IN_TRANSIT", "CANCELLED", "CLOSED"].includes(offerRequest?.status)
                                            }
                                            allowedLabels={offerRequest?.ownerStatus === "ADMIN_ACCEPTED" ? ["Rejected"] : ["Accepted", "Rejected"]}/>}

                                  {(offerRequest?.ownerStatus === "REJECTED" || offerRequest?.ownerStatus === "ADMIN_REJECTED") && offerRequest?.ownerRejectionNote && (
                                          <Tooltip
                                          title={`Rejection Note: ${offerRequest.ownerRejectionNote}`}
                                          arrow
                                          >
                                          <StickyNote2Icon
                                              className="note-icon cursor-pointer"
                                              style={{ color: "gray" }}
                                          />
                                          </Tooltip>
                                  )}
                                </td>
                                </>}
                          
                              </tr>
                              ):(<tr>
                                  <td colSpan={12} style={{ textAlign: 'center' }} className='border-0'>
                                    {/* Fetching records... */}
                                    <div style={{ height: "200px", display: "flex", alignItems: "center", justifyContent: "center" }}>
                                      <Customspinner />
                                    </div>
                                  </td>
                              </tr>)}
                            </tbody>
                          </Table>
                {/* )} */}
                        </div>
                        {viewDetails &&
                          <ViewProductDetail handleViewClose={handleViewClose} inventoryId={offerRequest?.inventoryId}/>
                        }
                    </div>
                  </div>
                </div>
              </div>
            </div>
            </div>
            <div className="row m-0">
                <div className="col-xl-6 mb-3 mb-xl-0 ps-0 pe-xl-2 pe-0">
                  <div className="orderDetail-footer-content-wrapper">
                  <div className="title-bar d-flex justify-content-between align-items-center mb-3">
                    <h3 className="mb-0">List of Documents</h3>
                    <UploadDocs
                      fetchData={fetchData}
                      csvId={id}
                      uploadCSV={false}
                      requestType={"OFFER_REQUEST"}
                      requestNumber= {offerRequest?.requestNumber}
                    />
                  </div>
                  <div
                    className="inventory-doc-table"
                    // style={{ height: 350, width: "100%" }}
                  >
          <><DataGrid
            localeText={localeText}
            rows={offerRequestDocs}
            columns={columnsForDoc}
            className="data-grid upload-doc-datagrid-table"
            // hideFooterPagination
            hideFooter
            loading={isLoading}
            disableColumnResize
          /></>
          {/* )} */}

                    
                  </div>
                  </div>
                </div>
                <div className="col-xl-6 mb-3 mb-xl-0 pe-0 ps-xl-2 ps-0">
                  <div className="recentActivity h-100">
                    <div className="title-bar d-flex justify-content-between align-items-center mb-3">
                      <h3 className="mb-0">Recent Activity</h3>
                    </div>
                    <div className="history-stepper-wrapper">
                      <HistoryStepper historyData={offerRequestHistoryData} />
                    </div>
                  </div>
                </div>
              </div>
          </div>
          {(isOpenEditSection || isMessageBoxOpen) && (
            <div className={`msgContainerBox ${isOpenEditSection ? "edit-box-wrapper" :"" }`}>
              {isOpenEditSection && (
                <EditRequest
                  requestType={"OFFER_REQUEST"}
                  id={id} //reload the date
                  refreshData={fetchData}
                  onEditClick={handleEditButtonClick}
                />
              )}
              {isMessageBoxOpen && (
                <ContainerMessageBox
                  requestType={"OFFER_REQUEST"}
                  sellerCompanyId={isSeller ? CommonService.getCompanyId() : null}
                  isSeller={isSeller}
                  wrapperHeight={wrapperHeight}
                />
              )}
            </div>
          )}
          {viewBarrelSelection && <BarrelSelectionPanel requestType={Constant.RequestType.OFFER_REQUEST} requestId={offerRequest?.id} orderItemId={null} inventoryId={offerRequest?.inventoryId} inventoryName={offerRequest?.inventoryName} requiredQuantity={offerRequest.quantity} companyName={offerRequest.inventoryOwnerCompanyName} currentStatus={offerRequest.status} handleCloseBarrelSelection={handleCloseBarrelSelection} />}
          {showMessageBox &&
                <div className="admin-message-box">
                  <div className="admin-message-box-left-inner" onClick={handleAdminMessageClick}></div>
                  <div className="admin-message-box-inner positio-relative"  ref={innerRef}>
                    <AdminMessageBox selectedGroup={""} requestId={id} 
                      requestType={Constant.RequestType.OFFER_REQUEST} unreadGroupsCount={unreadGroupsCount}
                      setUnreadGroupsCount={setUnreadGroupsCount} isSeller={isSeller} containerHeight={innerHeight}/>
                  </div>
                </div>
              }
        </div>
      </div>

      {/* Status Change Model Pop-up */}
      <Modal
        show={show}
        onHide={handleClose}
        className="modal__wd modal__wd--submitSellReq"
      >

      <Modal.Header className="flex-column align-items-start">
        {isOwnerStatusChange ? (
            <Modal.Title>Update Owner Status</Modal.Title>
        ) : (
            <Modal.Title>Update Offer Request Status</Modal.Title>
        )}
        <p className="modal-text mt-2">
            {isCancelled && (offerRequest?.status === "PENDING_REVIEW" || offerRequest?.status === "UNDER_REVIEW") && 
                "Are you sure you want to cancel?"}
            {isCancelled && !(offerRequest?.status === "PENDING_REVIEW" || offerRequest?.status === "UNDER_REVIEW") && 
                "Are you sure you want to cancel? A cancellation charge may apply."}
            {(isRejected || isOwnerStatusChange) && "Are you sure you want to change status to Rejected?"}
            {isInTransit && "Please enter Tracking Number"}
            {statusDetailsRef.current.status === Constant.OrderStatus.OWNERSHIP_TRANSFERRED && "Please Enter Date of transfer"}
            {statusDetailsRef.current.status === Constant.OrderStatus.CLOSED && "Once the request is closed, it cannot be reopened. Are you sure you want to close it?"}
            {!isInTransit && !isRejected && !isCancelled && !isOwnerStatusChange && !["OWNERSHIP_TRANSFERRED", "CLOSED"].includes(statusDetailsRef.current.status) && 
                `Are you sure you want to change status to ${formatStatus(statusDetailsRef.current.status)}?`
            }
        </p>
      </Modal.Header>

      {(isOwnerStatusChange || ["OWNERSHIP_TRANSFERRED", "SEND_TO_WAREHOUSE", "IN_TRANSIT", "REJECTED", "CANCELLED"].includes(statusDetailsRef.current.status)) && (
        <Modal.Body className="pb-1">
          <div className="form__inner">
           {isCancelled && (
            <textarea
            className={`form-control ${error ? "is_invalid" : ""}`}
            aria-label="With textarea"
            value={cancellationReason}
            onChange={handleCancellationReasonChange}
            rows={8}
            style={{ resize: "none" }}
            placeholder="Enter Cancellation Reason..."
          />
           )}
           {(isRejected || isOwnerStatusChange) && (<textarea
              className={`form-control ${error ? "is_invalid" : ""}`}
              aria-label="With textarea"
              value={rejectionNoteValue}
              onChange={handleRejectionNoteChange}
              rows={8}
              style={{ resize: "none" }}
              placeholder="Enter Rejection Note..."
            />)}
            {isInWarehouse && (
              <div className="form__inner">
                <label className="modal-body__title mb-1">Select Warehouse</label>
                <Select
                  className={`select-company-dropdown form-control w-100 multi-select-dropdown ${error ? "is_invalid" : ""
                    }`}
                  options={warehouseUserList.map((user) => ({
                    value: user.userId,
                    label: user.userName,
                  }))}
                  onChange={handleWarehouseUserChange}
                  components={{
                    DropdownIndicator: () => <ExpandMoreRoundedIcon />,
                    IndicatorSeparator: () => null, // Remove the default separator
                  }}
                  isSearchable
                  placeholder="Select Warehouse"
                />
              </div>
            )}
            {isInTransit && ( <><label className="modal-body__title mb-1">Track Number</label><Form.Control
              className={`form-control ${error ? "is_invalid" : ""}`}
              type="text"
              value={trackNumberValue}
              onChange={handleTrackingNumberChange}
              placeholder="Enter Tracking Number..." />
              </>
            )}
            {statusDetailsRef.current.status === Constant.OrderStatus.OWNERSHIP_TRANSFERRED && <>
              <label className="modal-body__title mb-1">Date of transfer</label>
              <Form.Control
                type="date"
                placeholder="OwnershipTransferDate"
                value={ownershipTransferDateValue}
                onChange={handleOwnershipTransferDateChange}
                onClick={handleDateClick}
                className={`form-control ${error ? "is_invalid" : ""}`}
                min={CommonService.getTodayInTimeZone()}
              /></>}
            {error && <div className="error-message">{error}</div>}

            {isInTransit && (<div className="d-flex align-items-center h-100 mt-2">
              <div className="create-ticket-attachement-wrapper d-flex flex-wrap align-items-center gap-1">
                <IconButton
                  type="button"
                  aria-label="submit"
                  sx={{
                    transform: "rotate(45deg)",
                    padding: "8px",
                  }}
                  onClick={handleButtonClick}
                >
                  <AttachFileIcon />
                </IconButton>
                <span className="cursor-pointer" onClick={handleButtonClick}>
                  Upload Document
                </span>
                <div className="d-flex align-items-center gap-2 flex-wrap">
                  {files?.map((file, index) => (
                    <div
                      className="file__upload--info d-flex align-items-center mb-1 me-2"
                      key={index}
                    >
                      <div className="file-name me-3">{file.name}</div>
                      <div className="file-delete">
                        <img
                          src={TrashIcon}
                          alt="TrashIcon"
                          onClick={() => handleDeleteFile(index)}
                        />
                      </div>
                    </div>
                  ))}
                </div>
                <div style={{ position: "relative" }}>
                  <input
                    type="file"
                    ref={fileInputRef}
                    style={{ display: "none" }}
                    multiple
                    onChange={handleFileChange}
                  />
                </div>
              </div>
            </div>
            )}
           
          </div>
        </Modal.Body>)}

        <Modal.Footer className={`justify-content-center 
          ${(isOwnerStatusChange || ["OWNERSHIP_TRANSFERRED", "SEND_TO_WAREHOUSE", "IN_TRANSIT", "REJECTED", "CANCELLED"].includes(statusDetailsRef.current.status)) ? '' : 'bg-transparent'}`}>
          <div className="btn-group row d-flex justify-content-between w-100">
            <div className="col-6 ps-0">
              <button
                className="secondary-btn w-100"
                onClick={handleClose}
                disabled={isLoading}
              >
                No
              </button>
            </div>

            <div className="col-6 pe-0">
              <button
                className="primary-btn w-100"
                onClick={isOwnerStatusChange ? changeOwnerStatus : changeOfferStatus}
                disabled={isLoading}
              >
                {isLoading && <Spinner />} {isCancelled ? "Cancel Request" : (isRejected || isOwnerStatusChange) ? "Reject Request" : "Yes"}
              </button>
            </div>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ViewOfferRequest;